import React from 'react'

import Experiment from '@mc/experiments-react'
import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import styles from 'components/Subscription/Subscription.module.scss'

import { MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME } from '../hooks/useTrackPen5222Experiment'
import { MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE } from '../i18n'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'

export const Pen5222NewValuePropWrapper = () => {
  const validExperimentCriteria = useExperimentCriteria()

  if (!validExperimentCriteria) return null

  return (
    <Experiment
      name={MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME}
      variant_1={ExtraValueProp}
      track={false}
    />
  )
}

const ExtraValueProp = () => {
  const { t } = useTranslation(MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE)

  return (
    <li className={`mc-my-3 ${styles.item}`}>
      <Icon className='mc-icon--3 mc-opacity--hinted mc-mr-3' kind='check' />
      {t('subscription.info.moneyBack')}
    </li>
  )
}
